import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import guardRoute from './guard-route'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  guardRoute(to, from, next)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js